import { render, staticRenderFns } from "./CaShipmentModal.vue?vue&type=template&id=23764350&scoped=true"
import script from "./CaShipmentModal.vue?vue&type=script&lang=js"
export * from "./CaShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./CaShipmentModal.vue?vue&type=style&index=0&id=23764350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23764350",
  null
  
)

export default component.exports